import { IconButton } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from "@mui/styles";

interface Props {
  onClose: () => void;
}

export default function CloseButton({ onClose }: Props) {
  const classes = useStyles();

  return (
    <IconButton
      aria-label="close"
      className={classes.closeButton}
      onClick={onClose}
      data-testid="close"
    >
      <CloseIcon />
    </IconButton>
  );
}

const useStyles = makeStyles({
  closeButton: {
    color: "#fff",
  },
});
